import { RootState } from 'store/types';

export const selectNewDashboardDashboards = (state: RootState) => state.newDashboard.dashboards;
